import { render, staticRenderFns } from "./AppAlert.vue?vue&type=template&id=dd032d7c&scoped=true"
import script from "./AppAlert.vue?vue&type=script&lang=js"
export * from "./AppAlert.vue?vue&type=script&lang=js"
import style0 from "./AppAlert.vue?vue&type=style&index=0&id=dd032d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd032d7c",
  null
  
)

export default component.exports